"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _index = _interopRequireDefault(require("./index.style"));
var _index2 = _interopRequireDefault(require("../../index.style"));
var _Button = _interopRequireDefault(require("../../../Button"));
const AddedGiftCard = _ref => {
  let {
    messages,
    addGiftCardHandler,
    removeGiftCardHandler,
    info,
    lastGiftCard,
    dictionaries
  } = _ref;
  const classes = (0, _index2.default)();
  const classesGiftCard = (0, _index.default)();
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: classesGiftCard.addedGiftCards
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classesGiftCard.addedGiftCardsWrapper
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classesGiftCard.addedGiftCardTitle
  }, /*#__PURE__*/_react.default.createElement("span", null, dictionaries.addedGiftCardendingCard, " "), /*#__PURE__*/_react.default.createElement("span", {
    className: classesGiftCard.addedGiftCardBlueText
  }, info.cardNumber.substr(-4)), ' ', /*#__PURE__*/_react.default.createElement("span", null, dictionaries.addedGiftCardWillBeCharged, " "), /*#__PURE__*/_react.default.createElement("span", {
    className: classesGiftCard.addedGiftCardBlueText
  }, info.balance.charged)), /*#__PURE__*/_react.default.createElement("div", {
    className: classesGiftCard.addedGiftCardRemainingBalance
  }, dictionaries.addedGiftCardRemainingBalance, " ", info.balance.remainingBalance), /*#__PURE__*/_react.default.createElement(_Button.default, {
    "data-testid": "remove-giftcard-2",
    onClick: () => removeGiftCardHandler(info.cardNumber),
    className: (0, _clsx.default)(classes.noStyleButton, classesGiftCard.removeTopBtn),
    disableRipple: true
  }, dictionaries.addedGiftCardRemoveCard), lastGiftCard && /*#__PURE__*/_react.default.createElement("div", {
    className: classesGiftCard.addedGiftCardMessage
  }, info.balance.addAnotherGiftCard ? messages.addAnother : messages.applied)), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classesGiftCard.buttonWrapper, !lastGiftCard && classesGiftCard.removeMarginTop, !info.balance.addAnotherGiftCard && classesGiftCard.removeMarginTop)
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    "data-testid": "remove-giftcard",
    onClick: () => removeGiftCardHandler(info.cardNumber),
    className: (0, _clsx.default)(classes.noStyleButton, classesGiftCard.removeDownBtn),
    disableRipple: true
  }, dictionaries.addedGiftCardRemoveCard), lastGiftCard && info.balance.addAnotherGiftCard && /*#__PURE__*/_react.default.createElement("span", {
    className: classesGiftCard.checkboxWrapper
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    "data-testid": "add-giftcard",
    onClick: addGiftCardHandler,
    className: classes.noStyleButton,
    disableRipple: true
  }, dictionaries.addedGiftCardAddAnotherGiftCard)))));
};
var _default = exports.default = AddedGiftCard;